__turbopack_context__.v({
  "about": "AboutTheProduct-module-scss-module__bsuR-W__about",
  "about__bullet": "AboutTheProduct-module-scss-module__bsuR-W__about__bullet",
  "about__bullets": "AboutTheProduct-module-scss-module__bsuR-W__about__bullets",
  "about__care-notes": "AboutTheProduct-module-scss-module__bsuR-W__about__care-notes",
  "about__guide-trigger": "AboutTheProduct-module-scss-module__bsuR-W__about__guide-trigger",
  "about__heading": "AboutTheProduct-module-scss-module__bsuR-W__about__heading",
  "about__stack": "AboutTheProduct-module-scss-module__bsuR-W__about__stack",
});
